import { styled } from '@mui/material';

const StyledStepDescription = styled('p')`
  font-size: 14px;
  color: var(--step-description-color);
`;

export default StyledStepDescription;
